import { TextInput, Typography } from "@strapi/design-system";
import { useTranslation } from "react-i18next";
import UploadFile from "../uploadFile";
import { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const ScientificArticle = ({ data, setData }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (data?.attachment) {
      let item = null;

      if (data?.attachment?.id) {
        item = {
          uid: data?.attachment?.id,
          name: data?.attachment?.name,
          url: data?.attachment?.url,
          status: "done",
        };
      } else {
        let uploadedImages = [];
        if (localStorage.getItem("uploaded_images")) {
          uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
        }

        if (uploadedImages.length > 0) {
          const img = uploadedImages.find((x) => x.id === data?.attachment);

          if (img) {
            item = {
              uid: img.id,
              name: img.name,
              url: img.url,
              status: "done",
            };
          } else {
            item = {
              uid: data?.attachment,
              name: data?.attachment?.name || "New File",
              url: data?.attachment?.url,
              status: "done",
            };
          }
        } else {
          item = {
            uid: data?.attachment,
            name: data?.attachment?.name || "New File",
            url: data?.attachment?.url,
            status: "done",
          };
        }
      }

      setFileList([item]);
    } else {
      setFileList([]);
    }
  }, [data?.attachment]);

  const handleSetName = (name) => {
    setData({ ...data, name });
  };

  const handleSetAuthorName = (author_name) => {
    setData({ ...data, author_name });
  };

  const handleSetYear = (date, dateString) => {
    setData({ ...data, year: dateString });
  };

  const handleSetIfIndex = (if_index) => {
    setData({ ...data, if_index });
  };

  const handleSetProjectName = (project_name) => {
    setData({ ...data, project_name });
  };

  const handleSetUrl = (url) => {
    setData({ ...data, url });
  };

  const handleSetIssnIsbn = (issn_isbn) => {
    setData({ ...data, issn_isbn });
  };

  const handleSetClassify = (classify) => {
    setData({ ...data, classify });
  };

  const handleSetNote = (note) => {
    setData({ ...data, note });
  };

  const handleChangeAttachment = (resFile) => {
    setData({
      ...data,
      attachment: resFile?.id,
    });
  };

  const handleRemoveAttachment = (id) => {
    setData({
      ...data,
      attachment: null,
    });
  };

  return (
    <div>
      <TextInput
        label={t("str_title_article_report")}
        name="project_name"
        onChange={(e) => handleSetProjectName(e.target.value)}
        value={data?.project_name || ""}
      />
      <br />
      <TextInput
        label={t("str_author_co_author")}
        name="author_name"
        onChange={(e) => handleSetAuthorName(e.target.value)}
        value={data?.author_name || ""}
      />
      <br />
      <TextInput
        label={t("str_magazine")}
        name="name"
        onChange={(e) => handleSetName(e.target.value)}
        value={data?.name || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_book_year_of_publication")}
      </Typography>
      <br />
      <DatePicker
        onChange={handleSetYear}
        picker="year"
        value={data?.year ? dayjs().year(data?.year) : null}
        className="custom-date-picker"
      />
      <br />
      <TextInput
        label={t("str_issn_isbn")}
        name="issn_isbn"
        onChange={(e) => handleSetIssnIsbn(e.target.value)}
        value={data?.issn_isbn || ""}
      />
      <br />
      <TextInput
        label={t("str_isi")}
        name="classify"
        onChange={(e) => handleSetClassify(e.target.value)}
        value={data?.classify || ""}
      />
      <br />
      <TextInput
        label={t("str_if_index")}
        name="if_index"
        onChange={(e) => handleSetIfIndex(e.target.value)}
        value={data?.if_index || ""}
      />
      <br />
      <TextInput
        label={t("str_note")}
        name="note"
        onChange={(e) => handleSetNote(e.target.value)}
        value={data?.note || ""}
      />
      <br />
      <TextInput
        label={t("str_attach_proof")}
        name="url"
        onChange={(e) => handleSetUrl(e.target.value)}
        value={data?.url || ""}
      />
      <br />
      <Typography variant="pi" fontWeight="bold">
        {t("str_or_and")}
      </Typography>
      <br />
      <span className="subnotes">{t("str_only_pdf")}</span>
      <br />
      <UploadFile
        fileMimeType={["application/pdf"]}
        fileTypeAllowNames="pdf"
        handleUploadSuccess={handleChangeAttachment}
        fileList={fileList}
        maxCount={1}
        handleRemoveFile={handleRemoveAttachment}
        accept="application/pdf"
      />
    </div>
  );
};

export default ScientificArticle;
